import { AccessAlarm } from '@mui/icons-material'
import { JSX } from 'react'

const AccessAlarmIcon = (): JSX.Element => <AccessAlarm />

export default AccessAlarmIcon
